import React from 'react';
import PropTypes from 'prop-types';
import Spinner from 'react-svg-spinner';

const Button = ({ className, type, onClick, showSpinner, disabled, children, style }) => {
  return (
    <button
      className={`${className}${showSpinner ? ' spinner' : ''}`}
      type={type}
      onClick={onClick}
      disabled={disabled}
      style={style}
    >
      <span className="button__content">{ children }</span>
      { showSpinner === true && <Spinner /> }
    </button>
  );
};

Button.defaultProps = {
  className: '',
  onClick: () => {},
  children: '',
  showSpinner: false,
  disabled: false,
  type: 'button',
  style: {}
};

Button.propTypes = {
  className: PropTypes.string,
  type: PropTypes.string,
  onClick: PropTypes.func,
  children: PropTypes.any,
  showSpinner: PropTypes.bool,
  disabled: PropTypes.bool,
  style: PropTypes.object
};

export default Button;
